const geolocation = {
    state: {
        browserSupport: true,

        // Map location
        latitudeDefault: 46.6493,
        latitude: 0,
        longitudeDefault: 14.3384,
        longitude: 0,
        error: null,

        // User position
        userPosition: null,
        watchID: null,
        trackingActive: false,
        GPSOptions: {
            enableHighAccuracy : true,
            //maximumAge: 3000
        }

    },
    mutations: {
        BROWSER_SUPPORT(state, value) {
            state.browserSupport = value
        },
        LOCATION(state, {latitude, longitude}) {
            state.latitude = latitude;
            state.longitude = longitude;
            console.log(`Location changed: ${latitude}, ${longitude}`)
        },
        LOCATION_ERROR(state, error) {
            state.error = {
                code: error.code,
                message: error.message
            };
        },
        USER_POSITION(state, GPSObject) {
            state.userPosition = GPSObject;
            console.log(`User position changed: ${GPSObject.latitude}, ${GPSObject.longitude}`)
        },
    },
    actions: {
        getUserPosition({state, commit}) {
            if (state.browserSupport && state.userPosition != null) {
                commit('LOCATION', {
                    latitude: state.userPosition.latitude,
                    longitude: state.userPosition.longitude
                })
            }
        },
        trackPosition({dispatch ,state ,commit}) {
            // Does browser support geolocation
            if (navigator && 'geolocation' in navigator) {
                commit('BROWSER_SUPPORT', true)

                // Listen to position changes
                state.watchID = navigator.geolocation.watchPosition(position => {
                        commit('USER_POSITION', position.coords)

                        if(state.trackingActive) {
                            dispatch('getUserPosition')
                        }
                    }, error => {
                        commit('LOCATION_ERROR', error)
                    }, state.GPSOptions
                )
            } else {
                commit('BROWSER_SUPPORT', false)
                commit('LOCATION', null)
                commit('LOCATION_ERROR', null)
            }
        },
        toggleTracking({state}) {
            state.trackingActive = !state.trackingActive
            console.log(`Tracking ${state.trackingActive ? 'enabled' : 'disabled'}`)
        },
        // Update user's position, either per GPS or Google search
        updateUserPosition({commit}, {latitude, longitude}) {
            let coords = {
                accuracy: 25,
                altitude: null,
                altitudeAccuracy: null,
                heading: null,
                latitude: latitude,
                longitude: longitude,
                speed: null
            }
            commit('USER_POSITION', coords)
        },
        // Update map's location
        updateLocation({commit}, {latitude, longitude}) {
            let latLng = {
                latitude: latitude,
                longitude: longitude
            }
            commit('LOCATION', latLng)
        }
    },
    getters: {
        userPosition(state) {
            return (state.userPosition)
                ? {lat: state.userPosition.latitude, lng: state.userPosition.longitude}
                : null
        },
        mapLocation(state) {
            return (state.latitude && state.longitude)
                ? {lat: state.latitude, lng: state.longitude}
                : null
        },
        mapLocationDefault(state) {
            return {lat: state.latitudeDefault, lng: state.longitudeDefault}
        },
        getTrackingStatus(state) {
            return state.trackingActive;
        }
    }
}

export default geolocation
